<template>
	<b-form-group class="mb-0">
		<template #label>
			<div class="d-flex justify-content-between align-items-center">
				<span>OBS browser source URL</span>
				<a :href="url" target="_blank" rel="noopener noreferrer"><small>Open widget <b-icon icon="box-arrow-up-right"/></small></a>
			</div>
		</template>
		<b-input-group size="">
			<b-form-input readonly :value="url" @focus="$event.target.select()" style="min-width: 300px"/>
			<b-input-group-append>
				<b-button type="button" variant="secondary" @click.capture.prevent.stop="copy">
					<b-icon icon="clipboard" /><span class="d-none d-sm-inline"> Copy</span>
				</b-button>
			</b-input-group-append>
		</b-input-group>
	</b-form-group>
</template>

<script>
export default {
	props: {
		url: { type: String, required: true },
	},
	methods: {
		copy() {
			this.$util.copyToClipboard(this.url);
			this.$bvToast.toast('Copied widget URL to clipboard', { title: 'Success', variant: 'success', solid: true });
		},
	},
};
</script>
